import { compact, flatten } from 'lodash';
import * as React from 'react';
import { useCustomEventEffect } from '../../shared/hooks/useCustomEventEffect';
import { visit } from '../../shared/utilities/turbolinks';
import { IFilter } from '../filters/IFilter';

interface IFilterEvent {
  filters: IFilter[];
}

interface IJobsFilter {
  jobsPath: string;
  target: string;
  buttonText?: string;
}

export default function JobsFilter({ jobsPath, target, buttonText = 'Search' }: IJobsFilter) {
  const [filters, setFilters] = React.useState<IFilter[]>([]);
  useCustomEventEffect<IFilterEvent>(`${target}:filter`, (event) => setFilters(event.detail.filters));

  function formattingParamsArray(filtersArray, id) {
    filters.filter((filter) => filter.attribute === id).map((filter) => filtersArray.push(filter.values));
    const flatArray = flatten(filtersArray);
    const filtersArrayResult = flatArray.length > 0 ? JSON.stringify(flatArray) : '';
    return filtersArrayResult;
  }

  const jobsPathWithParams = (options) => {
    return `${jobsPath}${jobsPath.includes('?') ? '&' : '?'}${compact(
      Object.keys(options).map((option) => {
        const value = options[option];
        if (!value) return;
        return `${option}=${value}`;
      }),
    ).join('&')}`;
  };

  function settingParams() {
    const locationFilters = [];
    const departmentFilters = [];
    const divisionFilters = [];
    const structureCustomGroupOneFilters = [];

    const availableFilters = filters.map((filter) => filter.attribute);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const searchQuery = urlParams.get('search');

    // Only add the additional params if a division or custom structure is present
    if (availableFilters.includes('structure_custom_group_one_id')) {
      visit(
        jobsPathWithParams({
          department_id: formattingParamsArray(departmentFilters, 'department_id'),
          division_id: formattingParamsArray(divisionFilters, 'division_id'),
          location_id: formattingParamsArray(locationFilters, 'location_id'),
          search: searchQuery,
          structure_custom_group_one_id: formattingParamsArray(
            structureCustomGroupOneFilters,
            'structure_custom_group_one_id',
          ),
        }),
      );
    } else if (availableFilters.includes('division_id')) {
      visit(
        jobsPathWithParams({
          department_id: formattingParamsArray(departmentFilters, 'department_id'),
          division_id: formattingParamsArray(divisionFilters, 'division_id'),
          location_id: formattingParamsArray(locationFilters, 'location_id'),
          search: searchQuery,
          structure_custom_group_one_id: formattingParamsArray(
            structureCustomGroupOneFilters,
            'structure_custom_group_one_id',
          ),
        }),
      );
    } else {
      visit(
        jobsPathWithParams({
          department_id: formattingParamsArray(departmentFilters, 'department_id'),
          location_id: formattingParamsArray(locationFilters, 'location_id'),
          search: searchQuery,
        }),
      );
    }
  }

  return (
    <button
      className="external-button external-button--theme-primary theme-primary-background-color-ie-override
      theme-primary-border-color-ie-override"
      onClick={settingParams}
    >
      {buttonText}
    </button>
  );
}
